// Short-URL stash for Studio deep-link prefills.
//
// A hub "start idea" carries the FULL change directive (title + description) as
// the Studio command-bar prefill — and that text is the actual image-gen prompt,
// so it must reach Studio verbatim (truncating it would corrupt the prompt).
// Putting the whole directive in the URL produced ~1.5 kB query strings.
//
// Instead the hub stashes the directive here keyed by the suggestion id and
// navigates with just `?suggestion=<id>`. Studio reads the stash back by id.
// sessionStorage (not memory) so the prefill also survives a same-tab reload of
// the deep link. A legacy `?prefill=<text>` query still works as a fallback for
// any externally-shared or pre-existing link.
const KEY = 'studio-prefill-stash';

export function stashStudioPrefill(id, text) {
  if (!id || typeof text !== 'string' || !text.trim()) return;
  try {
    sessionStorage.setItem(KEY, JSON.stringify({ id, text }));
  } catch (_) {
    // best-effort; falling back to the legacy ?prefill path is acceptable
  }
}

export function readStudioPrefill(id) {
  if (!id) return '';
  try {
    const raw = sessionStorage.getItem(KEY);
    if (!raw) return '';
    const parsed = JSON.parse(raw);
    return parsed && parsed.id === id && typeof parsed.text === 'string'
      ? parsed.text
      : '';
  } catch (_) {
    return '';
  }
}
